import { render, staticRenderFns } from "./RenyuandaishenheRight.vue?vue&type=template&id=2a31eb6c&scoped=true"
import script from "./RenyuandaishenheRight.vue?vue&type=script&lang=js"
export * from "./RenyuandaishenheRight.vue?vue&type=script&lang=js"
import style0 from "./RenyuandaishenheRight.vue?vue&type=style&index=0&id=2a31eb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31eb6c",
  null
  
)

export default component.exports